import { ProductGate } from "./ProductGate";

export function AresApp() {
  return <ProductGate appId="ares" />;
}
